<body *ngIf="!isLabSelected">
    <div class="container">
        <div class="row">
            <div class="col-sm-9 col-md-7 col-lg-5 mx-auto">
                <div class="card card-signin my-5">
                    <div class="card-body">
                        <img src="assets/BB_eurofins_icon.png" alt="BB_eurofins_icon">
                        <div class="form-group">
                            <h4 class="first">Lab</h4>
                            <p-dropdown [options]="labs" [(ngModel)]="selectedLab" placeholder="Select a Lab" optionLabel="label" [showClear]="true"
                                 [required]="true" [style]="{'width':'100%'}"></p-dropdown>
                        </div><br>                       
                        <button class="btn btn-primary btn-block text-uppercase w-12" (click)="assignLabAndLoad($event)">Proceed</button>
                        <hr class="my-4">
                        <div *ngIf="azureLoginStatus" style="text-align: center;">
                            Logged in as <span style="font-weight: bold;">{{loggedUserName}}</span>
                            <br>
                            <a class="logOutLink" (click)="azureLogOut()">
                                Login as a different User
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</body>